// ข้อมูลพนักงานจาก Wazzup — การเข้าสู่ระบบทำผ่าน SSO ของ IAM เท่านั้น (ดู lib/iam-sso.ts)
import { api } from "@shared/api/client";

export type Employee = {
  empCode: string;
  empThaiName?: string;
  empEngName?: string;
  nickName?: string;
  positionName?: string;
  departmentName?: string;
  profileURL?: string;
};

export const authKeys = {
  employees: ["auth", "employees"] as const,
  /** ผูกกับ token — ได้ token ใบใหม่ (คนละคน) แล้วต้องไม่ใช้โปรไฟล์ที่แคชไว้ */
  profile: (token: string) => ["auth", "profile", token] as const,
};

/** โปรไฟล์ที่ IAM คืนมา — เอาเฉพาะ field ที่หน้าเว็บใช้แสดง */
export type MyProfile = Employee & { userRole?: string[] };

/**
 * โปรไฟล์ของ token ใบที่ถืออยู่ — ใช้เติมชื่อ/ตำแหน่ง/รูป ให้ session ที่มาทาง SSO
 * (token จาก fragment มีแค่รหัสพนักงาน ไม่มีชื่อไทยหรือรูป)
 */
export async function fetchMyProfile(token: string): Promise<MyProfile> {
  const { data } = await api.get<MyProfile>("/wazzup/profile", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data ?? {};
}

/**
 * 401 ไม่ต้องดักที่นี่ — interceptor ใน shared/api/client.ts เป็นคนล้าง session
 * แล้วพาไป /login?expired=1 ให้ทุกหน้าเหมือนกัน (จุดเดียว ไม่ต้องจำว่าหน้าไหนเช็คแล้ว)
 */
export async function fetchEmployees(token: string): Promise<Employee[]> {
  const { data } = await api.get<Employee[]>("/wazzup/employees", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return Array.isArray(data) ? data : [];
}
